import React from 'react';
import { PraiseWrapper, PraiseHeader, PraiseTxt } from 'styled/PraiseStyled';

const Praise = () => {
  return (
    <PraiseWrapper>
      <PraiseHeader>Why people use Wave Finder</PraiseHeader>
      <PraiseTxt>&quot;It is the perfect place to find inspiration for
        upcoming trips!&quot;
      </PraiseTxt>
      <p><i>SurfTraveller82</i></p>
    </PraiseWrapper>
  )
}

export default Praise